import type { ReactNode } from 'react';
import { cn } from '~/lib/cn';

/** 1400px design content width with the 20px frame gutter from Figma. */
export function Container({ className, children }: { className?: string; children: ReactNode }) {
  return <div className={cn('mx-auto w-full max-w-[1440px] px-5', className)}>{children}</div>;
}
